export const content = {
  tr: {
    nav: {
      about: "Hakkımda",
      experience: "Deneyim",
      skills: "Yetenekler",
      projects: "Projeler",
      education: "Eğitim",
      contact: "İletişim",
    },
    hero: {
      overline: "FULL STACK WEB DEVELOPER — İSTANBUL",
      name: "İBRAHİM ŞİŞMAN",
      title: "Full Stack Web Developer",
      subtitle:
        "Bilişim Sistemleri Mühendisliği mezunu. D1-Tech'te React, .NET ve PostgreSQL ile full-stack web uygulamaları geliştiriyor; GitHub Actions ve Windows IIS ile DevOps süreçlerini de yönetiyorum.",
      cta: "İLETİŞİME GEÇ",
      ctaSecondary: "PROJELERİ GÖR",
      cvBtn: "CV İNDİR",
    },
    about: {
      overline: "HAKKIMDA",
      heading: "Merhaba, ben İbrahim.",
      paragraphs: [
        "Piri Reis Üniversitesi Bilişim Sistemleri Mühendisliği bölümünden mezun oldum. Geçtiğimiz Haziran'dan beri D1-Tech'te Full Stack Web Developer olarak çalışıyorum.",
        "Kariyerim boyunca üç farklı şirkette staj yapma fırsatı buldum: WordPress & PHP ile web geliştirme, Java & Spring Boot ile CRUD uygulamaları ve yazılım test süreçleri (Selenium, Cucumber, JMeter) üzerine kendimi geliştirdim.",
        "Şu anda React + .NET + PostgreSQL stack'i ile geliştirdiğim uygulamanın hem frontend hem backend tarafında çalışıyorum. Buna ek olarak uygulamanın DevOps sürecini de ben yönetiyorum: GitHub Actions ile CI/CD, manuel deployment ve Windows IIS üzerinde yayınlama.",
        "Geliştirme sürecimde yapay zeka araçlarını aktif olarak kullanıyorum: Başta Claude AI olmak üzere Codex, Emergent, ChatGPT ve Gemini gibi araçlarla üretkenliğimi en üst seviyeye çıkarıyorum.",
      ],
      stats: [
        { value: "3+", label: "Yıl Deneyim" },
        { value: "6", label: "Farklı Rol" },
        { value: "6", label: "Sertifika" },
        { value: "10+", label: "Teknoloji" },
      ],
    },
    experience: {
      overline: "KARİYER",
      heading: "Deneyim",
      present: "Devam ediyor",
      items: [
        {
          role: "Full Stack Web Developer",
          company: "D1-Tech",
          location: "İstanbul",
          date: "Haz 2025 — Devam",
          description:
            "Mezuniyetimin ardından D1-Tech'te Full Stack Web Developer olarak çalışıyorum. React, .NET ve PostgreSQL ile geliştirdiğim web uygulamasının uçtan uca sorumluluğunu üstleniyorum. Buna ek olarak uygulamanın DevOps sürecini de ben yönetiyorum: GitHub Actions ile CI/CD, manuel deployment ve Windows IIS üzerinde yayınlama.",
          tags: ["React", ".NET", "PostgreSQL", "GitHub Actions", "Windows IIS"],
        },
        {
          role: "Junior Software Developer",
          company: "D1-Tech",
          location: "İstanbul",
          date: "Tem 2024 — Haz 2025",
          description:
            "Gönüllü stajımın ardından yazılım geliştirici olarak çalışmaya başladım. Aktif bir web projesinde React (frontend), .NET (backend) ve PostgreSQL (veritabanı) kullanıyorum. Projenin hem frontend hem backend geliştirmesinde aktif rol aldım.",
          tags: ["React", ".NET", "PostgreSQL"],
        },
        {
          role: "Test Engineer Intern",
          company: "D1-Tech",
          location: "İstanbul",
          date: "Oca 2024 — Tem 2024",
          description:
            "Manuel testler yazdım ve test otomasyonu geliştirdim. Regression ve unit test gibi test türlerini öğrenip uyguladım. Selenium ve Cucumber ile otomasyon geliştirirken Appium ve Apache JMeter öğrendim. Waterfall, Agile ve Scrum gibi yazılım geliştirme süreçlerini deneyimledim.",
          tags: ["Selenium", "Cucumber", "JMeter", "Agile"],
        },
        {
          role: "Java Developer Intern",
          company: "Solvia Digital Solutions",
          location: "İstanbul",
          date: "Ağu 2023 — Eyl 2023",
          description:
            "Zorunlu stajımda yoğun olarak Java kullandım. Java ve Spring Boot eğitimi aldım, CRUD operasyonları gerçekleştiren bir Spring Boot projesi geliştirdim. MySQL veritabanı ve Postman ile pratik deneyim kazandım, API'lerle aktif olarak çalıştım.",
          tags: ["Java", "Spring Boot", "MySQL", "Postman"],
        },
        {
          role: "Data Specialist (Freelance)",
          company: "Spordata Information Technology",
          location: "İstanbul",
          date: "Kas 2022 — Devam",
          description:
            "1 yıldan uzun süredir freelance olarak veri toplama çalışmaları yapıyorum. Hemen her branştan sporu takip ederek anlık veri girişi yapıyorum. Yurt dışıyla sürekli iletişim halinde olduğum için İngilizcemi geliştiriyor, Excel tablolarıyla ve ekiple sürekli çalışıyorum.",
          tags: ["Veri Analizi", "Excel", "İngilizce"],
        },
        {
          role: "Database Assistant",
          company: "BurtiNet",
          location: "İstanbul",
          date: "Ağu 2022 — Eki 2022",
          description:
            "WordPress ile web sitesi oluşturmayı öğrendim. PHP kullanarak web sitesi veritabanlarını kontrol etme ve düzenleme deneyimi kazandım. Sunucu ve hosting hizmetlerinin sağlanmasını gözlemleme fırsatı buldum.",
          tags: ["WordPress", "PHP", "Hosting"],
        },
      ],
    },
    skills: {
      overline: "TEKNOLOJİLER",
      heading: "Yetenekler",
      groups: [
        {
          title: "Diller",
          items: ["Java", "Python", "C / C++", "SQL", "HTML / CSS", "JavaScript"],
        },
        {
          title: "Framework & Araçlar",
          items: ["Spring Boot", "React", ".NET", "Django", "PostgreSQL", "MySQL"],
        },
        {
          title: "DevOps",
          items: ["GitHub Actions", "CI/CD", "Windows IIS", "Manuel Deployment", "Git"],
        },
        {
          title: "AI Araçları",
          items: ["Claude AI", "Codex", "Emergent", "ChatGPT", "Gemini"],
        },
        {
          title: "Test & QA",
          items: ["Selenium", "Cucumber", "Apache JMeter", "Manuel Test", "Postman", "Appium"],
        },
      ],
      soft: {
        title: "Kişisel Özellikler",
        items: ["Çalışkanlık", "Takım Çalışması", "Sakinlik", "Hızlı Öğrenme"],
      },
    },
    projects: {
      overline: "PORTFOLYO",
      heading: "Projeler",
      items: [
        {
          title: "Kurumsal Web Projesi",
          description:
            "D1-Tech'te uçtan uca geliştirdiğim full-stack web uygulaması. Frontend, backend ve DevOps (GitHub Actions, Windows IIS) süreçlerinin tamamını yönetiyorum.",
          tags: ["React", ".NET", "PostgreSQL", "GitHub Actions"],
          featured: true,
        },
        {
          title: "Havacılık Web Sitesi",
          description: "HTML, CSS ve JavaScript ile sıfırdan geliştirdiğim havacılık temalı web sitesi.",
          tags: ["HTML", "CSS", "JavaScript"],
        },
        {
          title: "Spring Boot CRUD Uygulaması",
          description: "Java ve Spring Boot ile CRUD operasyonları gerçekleştiren backend uygulaması.",
          tags: ["Java", "Spring Boot", "MySQL"],
        },
        {
          title: "Django CV Sitesi",
          description: "Django öğrenirken geliştirdiğim, kendi CV'mi içeren kişisel web sitesi.",
          tags: ["Python", "Django"],
        },
      ],
    },
    education: {
      overline: "EĞİTİM & SERTİFİKALAR",
      heading: "Eğitim",
      school: "Piri Reis Üniversitesi",
      degree: "Bilişim Sistemleri Mühendisliği",
      date: "2020 — 2025",
      communities: {
        title: "Topluluklar",
        items: ["Google Developer Students Clubs", "COMPRU (Piri Reis Üniv. Bilişim Kulübü)"],
      },
      language: { title: "Yabancı Dil", items: ["İngilizce — B2"] },
      certsHeading: "Sertifikalar",
      certs: [
        { name: "Flutter Eğitim Sertifikası", org: "Piri Reis Üniversitesi", year: "2021" },
        { name: "Software - 101", org: "Akbank Academy & Microfon", year: "2023" },
        { name: "Cyber Security - 101", org: "Akbank Academy & Microfon", year: "2023" },
        { name: "SQL BootCamp", org: "Jose Portilla / Udemy", year: "2023" },
        { name: "Introduction to Cybersecurity", org: "Cisco", year: "2023" },
        { name: "NDG Linux Unhatched", org: "Cisco & NDG", year: "2023" },
      ],
    },
    contact: {
      overline: "İLETİŞİM",
      heading: "Birlikte çalışalım.",
      subtitle:
        "Yeni fırsatlara, projelere ve iş birliklerine her zaman açığım. Bana e-posta veya LinkedIn üzerinden ulaşabilirsiniz.",
      emailLabel: "E-posta",
      phoneLabel: "Telefon",
      linkedinLabel: "LinkedIn",
      locationLabel: "Konum",
      location: "İstanbul, Türkiye",
      footer: "Tasarım & Geliştirme — İbrahim Şişman",
    },
  },
  en: {
    nav: {
      about: "About",
      experience: "Experience",
      skills: "Skills",
      projects: "Projects",
      education: "Education",
      contact: "Contact",
    },
    hero: {
      overline: "FULL STACK WEB DEVELOPER — ISTANBUL",
      name: "İBRAHİM ŞİŞMAN",
      title: "Full Stack Web Developer",
      subtitle:
        "Information Systems Engineering graduate. Building full-stack web applications with React, .NET and PostgreSQL at D1-Tech, while also owning the DevOps process with GitHub Actions and Windows IIS.",
      cta: "GET IN TOUCH",
      ctaSecondary: "VIEW PROJECTS",
      cvBtn: "DOWNLOAD CV",
    },
    about: {
      overline: "ABOUT ME",
      heading: "Hi, I'm İbrahim.",
      paragraphs: [
        "I graduated in Information Systems Engineering from Piri Reis University. Since last June, I've been working as a Full Stack Web Developer at D1-Tech.",
        "Throughout my career I've had the opportunity to intern at three different companies: web development with WordPress & PHP, CRUD applications with Java & Spring Boot, and software testing processes (Selenium, Cucumber, JMeter).",
        "I'm currently working on both the frontend and backend of the application I develop with React + .NET + PostgreSQL. On top of that, I own the entire DevOps process: CI/CD with GitHub Actions, manual deployment and publishing on Windows IIS.",
        "I actively use AI tools in my development workflow: primarily Claude AI, along with Codex, Emergent, ChatGPT and Gemini to maximize my productivity.",
      ],
      stats: [
        { value: "3+", label: "Years Experience" },
        { value: "6", label: "Different Roles" },
        { value: "6", label: "Certificates" },
        { value: "10+", label: "Technologies" },
      ],
    },
    experience: {
      overline: "CAREER",
      heading: "Experience",
      present: "Present",
      items: [
        {
          role: "Full Stack Web Developer",
          company: "D1-Tech",
          location: "Istanbul",
          date: "Jun 2025 — Present",
          description:
            "After graduating, I continue working at D1-Tech as a Full Stack Web Developer. I take end-to-end responsibility for the web application I build with React, .NET and PostgreSQL. In addition, I own the application's DevOps process: CI/CD with GitHub Actions, manual deployment and publishing on Windows IIS.",
          tags: ["React", ".NET", "PostgreSQL", "GitHub Actions", "Windows IIS"],
        },
        {
          role: "Junior Software Developer",
          company: "D1-Tech",
          location: "Istanbul",
          date: "Jul 2024 — Jun 2025",
          description:
            "After my volunteer internship, I started working as a software developer. I was actively involved in a web project using React for frontend, .NET for backend and PostgreSQL as the database, taking an active role in both frontend and backend development.",
          tags: ["React", ".NET", "PostgreSQL"],
        },
        {
          role: "Test Engineer Intern",
          company: "D1-Tech",
          location: "Istanbul",
          date: "Jan 2024 — Jul 2024",
          description:
            "Wrote manual tests and developed test automation. Learned and applied regression and unit testing. Built automation with Selenium and Cucumber while learning Appium and Apache JMeter. Experienced software development processes such as Waterfall, Agile and Scrum.",
          tags: ["Selenium", "Cucumber", "JMeter", "Agile"],
        },
        {
          role: "Java Developer Intern",
          company: "Solvia Digital Solutions",
          location: "Istanbul",
          date: "Aug 2023 — Sep 2023",
          description:
            "Extensively used Java during my mandatory internship. Received training in Java and Spring Boot, and developed a Spring Boot project executing CRUD operations. Gained hands-on experience with MySQL and Postman, actively working with APIs.",
          tags: ["Java", "Spring Boot", "MySQL", "Postman"],
        },
        {
          role: "Data Specialist (Freelance)",
          company: "Spordata Information Technology",
          location: "Istanbul",
          date: "Nov 2022 — Present",
          description:
            "Doing data collection work as a freelancer for over a year. I follow sports from almost every branch, collecting and entering data in real time. Constant communication with international teams improves my English; I work with Excel and collaborate with a team daily.",
          tags: ["Data Analysis", "Excel", "English"],
        },
        {
          role: "Database Assistant",
          company: "BurtiNet",
          location: "Istanbul",
          date: "Aug 2022 — Oct 2022",
          description:
            "Learned how to create websites using WordPress. Gained experience checking and editing website databases using PHP. Had the opportunity to observe the provisioning of server and hosting services.",
          tags: ["WordPress", "PHP", "Hosting"],
        },
      ],
    },
    skills: {
      overline: "TECHNOLOGIES",
      heading: "Skills",
      groups: [
        {
          title: "Languages",
          items: ["Java", "Python", "C / C++", "SQL", "HTML / CSS", "JavaScript"],
        },
        {
          title: "Frameworks & Tools",
          items: ["Spring Boot", "React", ".NET", "Django", "PostgreSQL", "MySQL"],
        },
        {
          title: "DevOps",
          items: ["GitHub Actions", "CI/CD", "Windows IIS", "Manual Deployment", "Git"],
        },
        {
          title: "AI Tools",
          items: ["Claude AI", "Codex", "Emergent", "ChatGPT", "Gemini"],
        },
        {
          title: "Testing & QA",
          items: ["Selenium", "Cucumber", "Apache JMeter", "Manual Testing", "Postman", "Appium"],
        },
      ],
      soft: {
        title: "Soft Skills",
        items: ["Diligence", "Team Work", "Calm", "Fast Learning"],
      },
    },
    projects: {
      overline: "PORTFOLIO",
      heading: "Projects",
      items: [
        {
          title: "Enterprise Web Project",
          description:
            "Full-stack web application I develop end-to-end at D1-Tech, owning frontend, backend and the entire DevOps process (GitHub Actions, Windows IIS).",
          tags: ["React", ".NET", "PostgreSQL", "GitHub Actions"],
          featured: true,
        },
        {
          title: "Aviation Website",
          description: "An aviation-themed website built from scratch with HTML, CSS and JavaScript.",
          tags: ["HTML", "CSS", "JavaScript"],
        },
        {
          title: "Spring Boot CRUD App",
          description: "Backend application performing CRUD operations, built with Java and Spring Boot.",
          tags: ["Java", "Spring Boot", "MySQL"],
        },
        {
          title: "Django CV Site",
          description: "A personal website featuring my own CV, developed while learning Django.",
          tags: ["Python", "Django"],
        },
      ],
    },
    education: {
      overline: "EDUCATION & CERTIFICATES",
      heading: "Education",
      school: "Piri Reis University",
      degree: "Information Systems Engineering",
      date: "2020 — 2025",
      communities: {
        title: "Communities",
        items: ["Google Developer Students Clubs", "COMPRU (Piri Reis Univ. IT Club)"],
      },
      language: { title: "Languages", items: ["English — B2"] },
      certsHeading: "Certificates",
      certs: [
        { name: "Flutter Training Certificate", org: "Piri Reis University", year: "2021" },
        { name: "Software - 101", org: "Akbank Academy & Microfon", year: "2023" },
        { name: "Cyber Security - 101", org: "Akbank Academy & Microfon", year: "2023" },
        { name: "SQL BootCamp", org: "Jose Portilla / Udemy", year: "2023" },
        { name: "Introduction to Cybersecurity", org: "Cisco", year: "2023" },
        { name: "NDG Linux Unhatched", org: "Cisco & NDG", year: "2023" },
      ],
    },
    contact: {
      overline: "CONTACT",
      heading: "Let's work together.",
      subtitle:
        "I'm always open to new opportunities, projects and collaborations. Feel free to reach out via email or LinkedIn.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
      locationLabel: "Location",
      location: "Istanbul, Türkiye",
      footer: "Design & Development — İbrahim Şişman",
    },
  },
};

export const LINKS = {
  email: "ibrassmn@gmail.com",
  phone: "+90 546 453 82 13",
  phoneDisplay: "0546 453 82 13",
  linkedin: "https://www.linkedin.com/in/ibrahim-şişman-866541223",
};

export const MEDIA = {
  heroBackground:
    "https://images.unsplash.com/photo-1578662996442-48f60103fc96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxibGFjayUyMHRleHR1cmV8ZW58MHx8fHwxNzgxMjYxMTAzfDA&ixlib=rb-4.1.0&q=85",
  projectImages: [
    "https://images.pexels.com/photos/247791/pexels-photo-247791.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
};
